import { CatalogActions } from '../actions';

const initialState = '';

export function reducer(
  state = initialState,
  action: CatalogActions.CatalogClearState | CatalogActions.CatalogRootNodeIdLoadSuccess,
): string {
  switch (action.type) {
    case CatalogActions.LOAD_CATALOG_ROOT_NODE_ID_SUCCESS: {
      return action.payload;
    }

    case CatalogActions.CATALOG_CLEAR_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
